/* eslint-disable */
// GENERATED FILE - DO NOT EDIT
import React, { SVGProps } from "react";

const SvgWorkingFromHome = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Working from Home"
    width={29.326}
    viewBox="0 0 29.326 29.326"
    {...props}
  >
    <g data-name="Group 19">
      <g data-name="Group 17">
        <path
          data-name="Path 95"
          d="M14.658 17.501h.948a3.793 3.793 0 013.793 3.793v7.129a.474.474 0 01-.474.474H.906a.474.474 0 01-.474-.474v-7.129a3.793 3.793 0 013.793-3.793h10.433z"
          fill="#12b05e"
        />
        <g data-name="Group 15" fill="#ffcd27">
          <path
            data-name="Path 96"
            d="M10.864 23.191l.948 5.706H8.017l.948-5.706v-.392h1.9z"
          />
          <path
            data-name="Path 97"
            d="M10.864 23.191v-.392H9.547v.392l.948 5.706h1.317z"
          />
        </g>
        <path
          data-name="Path 98"
          d="M19.4 21.294a3.793 3.793 0 00-3.793-3.793h-1.316a3.793 3.793 0 013.792 3.793v7.129a.474.474 0 01-.474.474h1.317a.474.474 0 00.474-.474z"
          fill="#aecafc"
        />
        <path
          data-name="Path 99"
          d="M11.817 21.611l-.948 1.58h-1.9l-.952-1.58v-2.019l1.9.754 1.9-.754z"
          fill="#ffcd27"
        />
        <path
          data-name="Path 100"
          d="M10.87 19.967v1.016l-1.325 2.209h1.319l.948-1.58v-2.019z"
          fill="#f3bb00"
        />
        <path
          data-name="Path 101"
          d="M7.545 13.788h4.742v6.559H7.545z"
          fill="#fed2a4"
        />
        <path
          data-name="Path 102"
          d="M10.969 13.788h1.317v6.558h-1.317z"
          fill="#ffbd86"
        />
        <path
          data-name="Path 103"
          d="M7.545 16.552l-2.371.949 1.68 4.2a.474.474 0 00.7.218l2.359-1.573z"
          fill="#edf6ff"
        />
        <path
          data-name="Path 104"
          d="M12.287 16.552l2.371.949-1.68 4.2a.474.474 0 01-.7.218l-2.359-1.573z"
          fill="#edf6ff"
        />
        <g data-name="Group 16">
          <path
            data-name="Path 105"
            d="M14.661 6.12h.948a.948.948 0 01.948.948v1.9a.948.948 0 01-.948.948H4.225a.948.948 0 01-.948-.948v-1.9a.948.948 0 01.948-.948h10.436z"
            fill="#fed2a4"
          />
          <path
            data-name="Path 106"
            d="M9.916.602L5.174 4.886v5.028a4.742 4.742 0 009.484 0V4.886z"
            fill="#fed2a4"
          />
          <path
            data-name="Path 107"
            d="M13.34 3.695v6.218a4.742 4.742 0 01-4.083 4.7 4.738 4.738 0 005.4-4.7V4.885z"
            fill="#ffbd86"
          />
          <path
            data-name="Path 108"
            d="M12.287.43H7.544a2.371 2.371 0 00-2.37 2.371v2.371h.948a.948.948 0 00.948-.948v-.948h5.69v.948a.948.948 0 00.948.948h.948V2.801A2.371 2.371 0 0012.287.43z"
            fill="#3e5564"
          />
          <path
            data-name="Path 109"
            d="M12.286.43h-1.317a2.371 2.371 0 012.371 2.371v2.3a.946.946 0 00.369.074h.948V2.801A2.371 2.371 0 0012.286.43z"
            fill="#2b4150"
          />
        </g>
        <path
          data-name="Path 110"
          d="M13.29 16.954l-1.782 4.454.766.511a.474.474 0 00.7-.218l1.68-4.2z"
          fill="#d8e2f3"
        />
      </g>
      <g data-name="Group 18" fill="#3e5564">
        <path
          data-name="Path 111"
          d="M14.667 28.897H4.706a.474.474 0 01-.474-.474v-.949A.474.474 0 014.706 27h9.961z"
        />
        <path
          data-name="Path 112"
          d="M27.948 26.999a.949.949 0 00.949-.949V15.613a.949.949 0 00-.949-.949H14.667a.949.949 0 00-.949.949v10.438a.949.949 0 00.949.949v.286h13.281z"
        />
        <path
          data-name="Path 113"
          d="M27.948 14.664h-1.317a.949.949 0 01.949.949v10.438a.949.949 0 01-.949.949v.286h1.317V27a.949.949 0 00.949-.949V15.613a.949.949 0 00-.949-.949z"
        />
        <path
          data-name="Path 114"
          d="M28.438 28.897H14.176a.458.458 0 01-.458-.458v-.981a.458.458 0 01.458-.458h14.262a.458.458 0 01.458.458v.981a.458.458 0 01-.458.458z"
        />
        <path
          data-name="Path 115"
          d="M28.439 26.999h-1.314a.458.458 0 01.458.458v.981a.458.458 0 01-.458.458h1.314a.458.458 0 00.458-.458v-.981a.458.458 0 00-.458-.458z"
        />
      </g>
    </g>
    <g data-name="Group 20">
      <path
        data-name="Path 116"
        d="M8.448 8.021v-.474a.43.43 0 10-.859 0v.474a.43.43 0 10.859 0z"
      />
      <path
        data-name="Path 117"
        d="M11.814 8.451a.43.43 0 00.43-.43v-.474a.43.43 0 10-.859 0v.474a.43.43 0 00.429.43z"
      />
      <path
        data-name="Path 118"
        d="M11.52 10.727a.43.43 0 00-.744-.43.994.994 0 01-1.721 0 .43.43 0 10-.744.43 1.853 1.853 0 003.209 0z"
      />
      <path
        data-name="Path 119"
        d="M29.326 15.612a1.38 1.38 0 00-1.378-1.378H17.414a.43.43 0 100 .859h10.534a.52.52 0 01.519.519V26.05a.52.52 0 01-.519.519H14.667a.52.52 0 01-.519-.519V15.612a.52.52 0 01.519-.519H15.7a.43.43 0 100-.859h-1.033a1.38 1.38 0 00-1.378 1.378v.888l-.572-.229v-2a5.179 5.179 0 002.354-3.918h.537a1.38 1.38 0 001.378-1.383v-1.9a1.38 1.38 0 00-1.378-1.379h-.519V2.8a2.8 2.8 0 00-2.8-2.8H7.544a2.8 2.8 0 00-2.8 2.8v2.893h-.52a1.38 1.38 0 00-1.378 1.379v1.9a1.38 1.38 0 001.378 1.379h.537a5.178 5.178 0 002.354 3.918v2l-2.025.81h-.866A4.229 4.229 0 000 21.306v3.307a.43.43 0 10.859 0v-3.307a3.369 3.369 0 013.365-3.366h.658l1.572 3.931a.9.9 0 001.341.417l.087-.058.636 1.059-.547 3.28H4.707a.9.9 0 00-.9.9v.994H.9a.045.045 0 01-.045-.045v-2.087a.43.43 0 10-.859 0v2.091a.9.9 0 00.9.9h27.543a.889.889 0 00.888-.888v-.981a.884.884 0 00-.25-.616 1.371 1.371 0 00.25-.791zM11.861 26.569l-.547-3.28.636-1.059.087.058a.9.9 0 001.252-.249v4.011a1.37 1.37 0 00.1.519h-1.53zm1.428-6.79l-.709 1.773a.042.042 0 01-.028.026.042.042 0 01-.038-.006L10.5 20.231l1.96-3.138.828.331v2.355zm2.319-13.226a.52.52 0 01.519.519v1.9a.52.52 0 01-.519.519h-.519V6.553zM7.544.859h4.743A1.945 1.945 0 0114.23 2.8v1.945h-.519a.52.52 0 01-.519-.519v-.52h.045a.43.43 0 000-.859H6.6a.43.43 0 100 .859h.04v.519a.52.52 0 01-.519.519H5.6V2.8A1.944 1.944 0 017.544.859zM3.7 8.97v-1.9a.52.52 0 01.519-.519h.519v2.938h-.514A.52.52 0 013.7 8.97zm1.9.949V5.6h.519A1.38 1.38 0 007.5 4.225v-.519h4.833v.519A1.38 1.38 0 0013.71 5.6h.519v4.319a4.314 4.314 0 11-8.627 0zm4.314 5.174a5.143 5.143 0 001.942-.379v1.724l-1.94 3.108-1.942-3.108v-1.724a5.145 5.145 0 001.942.379zM7.28 21.578a.042.042 0 01-.028-.026l-1.521-3.8 1.639-.656 1.96 3.138-2.012 1.339a.042.042 0 01-.038.005zm2.636-.705l1.318.879-.613 1.022h-1.41L8.6 21.752zm-.585 2.76H10.5l.489 2.936H8.842zm-4.669 3.84a.045.045 0 01.045-.045h8.583v1.039H4.707a.045.045 0 01-.045-.045v-.949zm23.805.965a.029.029 0 01-.029.029H14.177a.029.029 0 01-.029-.029v-.981a.029.029 0 01.029-.029h14.262a.029.029 0 01.029.029z"
      />
      <path
        data-name="Path 120"
        d="M16.135 23.694a.889.889 0 00.888.888h8.57a.889.889 0 00.888-.888v-5.726a.889.889 0 00-.888-.888h-8.57a.889.889 0 00-.888.888zm.859-5.726a.029.029 0 01.029-.029h8.57a.029.029 0 01.029.029v5.726a.029.029 0 01-.029.029h-8.57a.029.029 0 01-.029-.029z"
      />
    </g>
  </svg>
);

SvgWorkingFromHome.defaultProps = {};
export default SvgWorkingFromHome;
/* eslint-enable */
